import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

export const StyledAccountSignalTypeCard = styled.button<{ $isClickable: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    height: 140px;
    padding: 16px 20px;
    border-radius: 8px;
    border: 1px solid ${rgba(colorsPalettes.carbon[50], 0.5)};
    background: ${colorsPalettes.carbon[25]};
    text-align: left;
    cursor: ${({ $isClickable }) => ($isClickable ? "pointer" : "default")};
    transition:
        border-color 0.2s ease,
        background-color 0.2s ease;

    &:hover:not(:disabled) {
        background: ${({ $isClickable }) => ($isClickable ? colorsPalettes.carbon[25] : undefined)};
        border-color: ${({ $isClickable }) => ($isClickable ? colorsPalettes.carbon[100] : undefined)};
    }

    &:active:not(:disabled) {
        background: ${({ $isClickable }) => ($isClickable ? colorsPalettes.blue[50] : undefined)};
        border-color: ${({ $isClickable }) => ($isClickable ? colorsPalettes.blue[400] : undefined)};
    }

    &:disabled {
        cursor: default;
    }
`;

export const StyledAccountSignalTypeCardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    width: 100%;

    @media (max-width: 1100px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;
